/* eslint-disable import/prefer-default-export */
import YouTube from 'react-youtube';

import { State } from '../models';
import { INITIAL_HEALTH } from './mechanics';

export const DEFAULT_STATE: State = {
  youTubePlayerState: YouTube.PlayerState.UNSTARTED,
  startTime: -1,
  renderedBarIdx: -1,
  videoTime: -1,
  videoDelta: -1,
  renderedNoteIdx: -1,

  // Play
  problemIdxs: [0, -1],
  attemptableIdxs: [0, 0],
  cumCorrect: true,
  cumSpecial: false,
  attempts: [],
  health: INITIAL_HEALTH,
  gotSpecial: false,

  // Record
  timings: [],
};
